<template>
    <div class="min-h-screen bg-gray-100">

        <Head title="Gerenciamento de Atividades" />

        <div class="shadow_box rounded-lg p-6 relative flex flex-col">
            <p class="title"><strong>Pesquisa</strong></p>
            <form class="mt-1 w-full" @submit.prevent>
                <div class="flex flex-wrap mb-4 px-4">
                    <multi-select-input v-model="filters.ActivityManagement.sales_promoter" :multiple="true"
                        :options="options.salesPromoterSearch" class="lg:pr-6 w-full lg:w-1/4" label="Promotor" />
                    <multi-select-input v-model="filters.ActivityManagement.market_network" :multiple="true"
                        :options="options.marketNetworkSearch" class="lg:pr-6 w-full lg:w-1/4" label="Rede" />
                    <multi-select-input v-model="filters.ActivityManagement.market" :multiple="true"
                        :options="options.marketSearch" class="lg:pr-6 w-full lg:w-1/4" label="Loja" />
                    <multi-select-input v-model="filters.ActivityManagement.provider" :multiple="true"
                        :options="options.providerSearch" class="lg:pr-6 w-full lg:w-1/4" label="Fornecedor" />
                    <multi-select-input v-model="filters.ActivityManagement.brand" :multiple="true"
                        :options="options.brandSearch" class="lg:pr-6 w-full lg:w-1/4 mt-3" label="Marca" />
                    <multi-select-input v-model="filters.ActivityManagement.products" :multiple="true"
                        :options="options.productSearch" class="lg:pr-6 w-full lg:w-1/4 mt-3" label="Produtos" />
                    <multi-select-input v-model="filters.ActivityManagement.state" :multiple="true"
                        :options="options.statesSearch" class="lg:pr-6 w-full lg:w-1/4 mt-3" label="Estado" />
                    <multi-select-input v-model="filters.ActivityManagement.city" :multiple="true"
                        :options="options.citysSearch" class="lg:pr-6 w-full lg:w-1/4 mt-3" label="Cidade" />
                    <multi-select-input v-model="filters.ActivityManagement.zone" :multiple="true"
                        :options="options.zoneSearch" class="lg:pr-6 w-full lg:w-1/4 mt-3" label="Região" />
                    <div class="flex flex-shrink-0 flex-wrap items-center justify-start mt-7 p-4 rounded-b-md gap-1">
                        <button @click="reloadData"
                            class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out">
                            <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
                            Pesquisar
                        </button>
                        <button class="btn flex items-center text-purple-100 font-roboto font-medium
       px-6 py-2.5 text-xs leading-tight uppercase border-solid border-2 border-purple-100" @click="clearSearch">
                            <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
                            Limpar
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <div class="shadow_box rounded-lg p-0 mt-4 overflow-hidden">
            <div class="px-6 py-4 flex items-center justify-between">
                <div class="flex items-center">
                    <h1 class="text-xl font-semibold text-gray-900">Gerenciamento de atividades</h1>
                    <span
                        class="inline-flex items-center justify-center w-5 h-5 ml-2 text-xs font-bold text-white bg-blue-600 rounded-full">?</span>
                </div>
                <div class="text-sm text-gray-600"></div>
            </div>

            <div class="px-6 py-3 mx-4 rounded-lg flex items-center justify-between bg-white border border-gray-200">
                <div class="inline-flex items-center px-3 py-1 text-gray-700 text-sm">
                    Relatório de atividades
                </div>
                <div class="text-sm text-gray-600 flex items-center gap-2">
                    <span>{{ totalLeft.toLocaleString('pt-BR') }} registros</span>
                    <button @click="reloadData" title="Recarregar dados"
                        class="p-1 rounded text-gray-600 hover:bg-gray-100 border border-transparent hover:border-gray-200">
                        <font-awesome-icon icon="fa-sync-alt" />
                    </button>
                </div>
            </div>

            <div class="grid grid-cols-12 gap-0">
                <div class="col-span-12 lg:col-span-8 px-4">
                    <div class="h-screen overflow-auto scrollbar-thin scrollbar-thumb-blue-800 scrollbar-track-blue-200"
                        ref="leftScroll">
                        <data-table v-if="loadTable" ref="leftTable" v-model:columns="leftColumns"
                            :route="'/activity_management/list-feed'" :query="getQuery" :disable-search="true"
                            :disable-navigation="true" :infinite-scroll="useInfiniteScrollLeft" thead-class="hidden">
                            <!-- Paginação: ocultar com infinite-scroll; manter total atualizado -->
                            <template #label.pagination="{ from, to, total }">
                                <span v-if="!useInfiniteScrollLeft" class="text-bold">Exibindo {{ from }} - {{ to }} de
                                    {{ total }} registros.</span>
                                <span class="hidden" v-if="updateTotalLeft(total)"></span>
                            </template>
                            <template #table.cell.content.sales_promoter_label="{ value, row }">
                                <div class="rounded-lg bg-white border border-gray-200 mb-4">
                                    <div class="px-4 py-8 flex items-center justify-between">
                                        <div class="flex items-center gap-3">
                                            <div
                                                class="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center">
                                                <font-awesome-icon icon="fa-user" class="text-gray-600" />
                                            </div>
                                            <div class="text-sm font-medium text-gray-900">{{ value }}</div>
                                        </div>
                                        <div class="flex items-center gap-4 text-xs text-gray-600">
                                            <div class="flex items-center gap-1 text-gray-600">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                    class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="1.5"
                                                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                                    <path
                                                        d="M12 2C8.686 2 6 4.686 6 8c0 4.418 6 12 6 12s6-7.582 6-12c0-3.314-2.686-6-6-6Zm0 8.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z" />
                                                </svg>
                                                <Link
                                                    :href="'/market_provider/' + (row.marketNetWorkId || row.marketNetworkId) + '/' + row.marketId"
                                                    class="text-blue-600 hover:underline">{{ row.marketNetworkName }} -
                                                {{
                                                    row.marketUnit }}</Link>
                                            </div>
                                            <div class="flex items-center gap-1">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                    class="w-4 h-4 text-gray-600" fill="none" stroke="currentColor"
                                                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                                                    aria-hidden="true">
                                                    <path d="M6.75 3v2.25M17.25 3v2.25M3.75 8.25h16.5" />
                                                    <path
                                                        d="M4.5 6.75A2.25 2.25 0 0 1 6.75 4.5h10.5A2.25 2.25 0 0 1 19.5 6.75v10.5A2.25 2.25 0 0 1 17.25 19.5H6.75A2.25 2.25 0 0 1 4.5 17.25V6.75Z" />
                                                </svg>
                                                <span>{{ formatDate(row.date) }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="px-4 pt-3 text-xs text-gray-600 flex gap-6 border-b border-gray-200"
                                        role="tablist">
                                        <button v-for="(p, idx) in getPhotos(row)" :key="idx"
                                            @click.stop="selectPhoto(row, idx)" :class="[
                                                'pb-2 -mb-[1px] border-b-4',
                                                isPhotoActive(row, idx)
                                                    ? 'text-gray-800 font-bold border-purple-100'
                                                    : 'text-gray-600 border-transparent hover:text-gray-800'
                                            ]" role="tab" :aria-selected="isPhotoActive(row, idx)">
                                            {{ labelMedia(idx) }}
                                        </button>

                                        <button v-if="getPhotos(row).length === 0"
                                            class="pb-2 -mb-[1px] border-b-2 border-transparent text-gray-400 cursor-default"
                                            disabled role="tab" aria-selected="true">
                                            Mídia 01
                                        </button>
                                    </div>

                                    <div class="px-4 grid grid-cols-3 gap-4 text-xs text-gray-700 mt-3">
                                        <div><span class="font-medium">Fornecedor:</span> {{ row.providerName }}</div>
                                        <div><span class="font-medium">Marca:</span> {{ row.brandName }}</div>
                                        <div><span class="font-medium">Ruptura:</span> {{ row.nostock ? 'Sim' : 'Não' }}
                                        </div>
                                    </div>

                                    <div
                                        class="relative w-full bg-gray-100 rounded-md my-4 flex items-center justify-center text-gray-400 overflow-hidden">
                                        <Image v-if="showImage(row)" :src="currentPhoto(row)" alt="Mídia"
                                            class="aspect-video w-full" imageClass="h-full mx-auto"
                                            @error="onImageError(row)" preview />
                                        <span class="text-center py-5" v-else>{{ getImageFallbackText(row) }}</span>
                                        <button @click.stop="prevPhoto(row)" :disabled="!canNavigate(row)" :class="[
                                            'absolute left-2 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-white shadow flex items-center justify-center text-gray-600',
                                            { 'opacity-50 cursor-not-allowed': !canNavigate(row) }
                                        ]" title="Anterior">
                                            <span>&lt;</span>
                                        </button>
                                        <button @click.stop="nextPhoto(row)" :disabled="!canNavigate(row)" :class="[
                                            'absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-white shadow flex items-center justify-center text-gray-600',
                                            { 'opacity-50 cursor-not-allowed': !canNavigate(row) }
                                        ]" title="Próxima">
                                            <span>&gt;</span>
                                        </button>
                                    </div>

                                    <div class="px-4 text-xs text-gray-700 mb-2">
                                        <span class="font-medium">Produtos:</span>
                                        <span class="ml-1">{{ row.productsText }}</span>
                                    </div>

                                    <div class="px-4 pb-4 text-[12px] text-gray-600">
                                        {{ row.description }}
                                    </div>

                                    <div class="px-4 pb-4 flex flex-col gap-4">
                                        <div class="text-[11px] text-gray-500">Publicado: {{ row.date_for_humans ||
                                            formatDateTime(row.date) }}
                                        </div>
                                        <div class="flex items-center gap-2">
                                            <button @click.stop="handleDelete(row)"
                                                class="px-3 py-1 rounded text-xs font-medium bg-red-500 hover:bg-red-600 text-white">Excluir</button>
                                            <button @click.stop="handleEdit(row)"
                                                class="px-3 py-1 rounded text-xs font-medium bg-gray-600 hover:bg-gray-700 text-white">Editar</button>
                                            <button @click.stop="handleOrient(row)"
                                                class="px-3 py-1 rounded text-xs font-medium bg-orange-500 hover:bg-orange-600 text-white">Orientar</button>
                                            <button @click.stop="handleApprove(row)"
                                                class="px-3 py-1 rounded text-xs font-medium bg-green-500 hover:bg-green-600 text-white">Aprovar</button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </data-table>
                        <!-- Sentinel do scroll infinito -->
                        <div ref="leftSentinel" class="h-6"></div>
                    </div>
                </div>

                <div class="col-span-12 lg:col-span-4 border-gray-200 pr-4 pt-4">
                    <div class="bg-white rounded-lg border border-gray-200">
                        <div class="font-medium text-gray-700 px-4 pt-8">Gerenciamento de atividade</div>
                        <div class="px-4 pb-8 border-b border-gray-100 flex items-center justify-between">
                            <div class="text-sm text-gray-700">Promotor</div>
                            <div class="text-xs text-gray-500 mr-10">Ações</div>
                        </div>
                        <div class="p-0 h-[calc(100vh-7rem)] overflow-auto scrollbar-thin scrollbar-thumb-blue-800 scrollbar-track-blue-200"
                            ref="rightScroll">
                            <data-table v-if="loadTable" ref="rightTable" v-model:columns="listColumns"
                                :route="'/activity_management/list-latest-per-promoter'" :query="getQuery"
                                no-data-label="Nenhuma atividade cadastrada"
                                no-result-label="Nenhuma atividade encontrada" :disable-search="true"
                                :disable-navigation="true" :infinite-scroll="useInfiniteScrollRight"
                                thead-class="hidden" :disable-pagination-label="true">
                                <!-- Paginação direita: suprimida no infinite-scroll -->
                                <template #label.pagination>
                                    <!-- vazio intencionalmente -->
                                </template>
                                <template #table.cell.content.sales_promoter_label="{ value, row }">
                                    <div class="px-4 py-3 border-b border-gray-100 flex items-start gap-3 cursor-pointer hover:bg-gray-50"
                                        @click="applyPromoterFilter(row)">
                                        <div
                                            class="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center text-gray-600">
                                            <font-awesome-icon icon="fa-user" />
                                        </div>
                                        <div class="flex-1 min-w-0">
                                            <div class="text-sm font-medium text-gray-900 truncate">{{ value }}
                                            </div>
                                            <div class="text-xs text-gray-600 truncate">
                                                Mercado:
                                                <Link
                                                    :href="'/market_provider/' + (row.marketNetWorkId || row.marketNetworkId) + '/' + row.marketId"
                                                    class="text-blue-600 hover:underline">{{ row.marketNetworkName }} -
                                                {{
                                                    row.marketUnit }}</Link>
                                            </div>
                                            <div class="text-[11px] text-gray-500">{{
                                                row.date_for_humans }}</div>
                                        </div>
                                        <div class="flex flex-col gap-2">
                                            <button @click.stop="handleDelete(row)"
                                                class="px-3 py-1 rounded text-xs font-medium bg-red-500 hover:bg-red-600 text-white">Excluir</button>
                                            <button @click.stop="handleOrient(row)"
                                                class="px-3 py-1 rounded text-xs font-medium bg-orange-500 hover:bg-orange-600 text-white">Orientar</button>
                                            <button @click.stop="handleApprove(row)"
                                                class="px-3 py-1 rounded text-xs font-medium bg-green-500 hover:bg-green-600 text-white">Aprovar</button>
                                        </div>
                                    </div>
                                </template>
                            </data-table>
                            <!-- Sentinel do scroll infinito -->
                            <div ref="rightSentinel" class="h-6"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <modal-edit :modal-scrollable="true" ref="modalReprovar" url="activity_management/update-status"
        @submitForm="onModalSubmit" @submitError="onModalError" id="modal-reprovar-activity">
        <template #header>
            <div class="text-gray-777 font-roboto uppercase">
                <span>Orientar atividade</span>
            </div>
        </template>
        <template #form="{ item }">
            <div class="text-center w-full">
                <font-awesome-icon icon="fa-list" class="text-orange-500 text-2xl" />
                <div class="mt-4 mb-4">Deseja orientar essa atividade?</div>
            </div>
            <textarea-input v-model="item.feedback" :error="item.errors && item.errors.feedback"
                class="lg:pr-6 w-full mb-3" label="Justificativa" />
        </template>
    </modal-edit>

    <modal-edit :modal-scrollable="true" ref="modalAprovar" url="activity_management/update-status"
        @submitForm="onModalSubmit" @submitError="onModalError" id="modal-aprovar-activity">
        <template #header>
            <div class="text-gray-777 font-roboto uppercase">
                <span>Aprovar atividade</span>
            </div>
        </template>
        <template #form>
            <div class="text-center w-full">
                <font-awesome-icon icon="fa-list-check" class="text-green-600 text-2xl" />
                <div class="mt-4 mb-4">Deseja aprovar essa atividade?</div>
            </div>
        </template>
    </modal-edit>

    <modal-edit :modal-scrollable="true" ref="modalExcluir" url="activity_management/destroy-activity"
        @submitForm="onModalSubmit" @submitError="onModalError" id="modal-excluir-activity">
        <template #header>
            <div class="text-gray-777 font-roboto uppercase">
                <span>Excluir atividade</span>
            </div>
        </template>
        <template #form>
            <div class="text-center w-full">
                <font-awesome-icon icon="fa-trash-can" class="text-red-600 text-2xl" />
                <div class="mt-4 mb-4">Deseja excluir essa atividade?</div>
            </div>
        </template>
    </modal-edit>

    <modal-edit ref="modalEdit" title="Atividade" url="activity_management/store" id="modal-edit-feed"
        @submitForm="onModalSubmit" @submitError="onModalError">
        <template #form="{ item }">
            <multi-select-input appendTo="#modal-edit-feed" v-model="item.products" :multiple="true"
                :options="productOptionsDisp" :error="item.errors && item.errors.products"
                class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Produtos" optionLabel="label" required="true" />

            <radiobox v-model="item.nostock" :options="options_sim_nao" class="lg:pr-6 w-1/2 mt-6"
                :error="item.errors && item.errors.nostock" label="Ruptura" />

            <textarea-input v-model="item.description" :error="item.errors && item.errors.description"
                class="lg:pr-6 w-full mb-3" label="Texto" />
            <div class="w-full">
                <button class="px-3 py-2 text-xs font-roboto font-medium btn-invalid uppercase"
                    @click.prevent="item.photo.push({})">
                    <span class="hidden lg:block">Adicionar Foto</span>
                </button>
            </div>
            <div class="grid grid-cols-2 md:grid-cols-3 gap-4">
                <div v-for="(photo, index) in item.photo" :key="index">
                    <div class="overflow-hidden">
                        <photo-input-cropped v-model="item.photo[index]" class="mt-10 w-full" type="file"
                            label="Foto" />
                    </div>
                </div>
            </div>
        </template>
    </modal-edit>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'


import Layout from '@/Shared/Layout'
import DataTable from '@/Shared/DataTable'
import DateInput from '@/Shared/DateInput'
import MultiSelectInput from '@/Shared/MultiSelectInput'
import ModalEdit from '@/Shared/ModalEdit'
import TextareaInput from '@/Shared/TextareaInput.vue'
import PhotoInputCropped from '@/Shared/PhotoInputCropped.vue'
import Radiobox from '@/Shared/RadioInput.vue'
import Image from 'primevue/image'


import axios from 'axios'
import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'
import { getFiltersMixin } from '@/Mixins/GetFilters'

export default {
    components: {
        Head,
        DateInput,
        DataTable,
        MultiSelectInput,
        Link,
        ModalEdit,
        TextareaInput,
        PhotoInputCropped,
        Radiobox,
        Image
    },
    props: {
        statustSearch: Array,
        salesPromoterSearch: Array,
    },
    layout: Layout,

    mixins: [
        getFiltersMixin,
    ],
    data() {
        return {
            loadTable: true,
            showFilters: false,
            exportedTable: true,
            isExporting: false,
            totalLeft: 0,
            // scroll infinito x paginação
            useInfiniteScrollLeft: true,
            useInfiniteScrollRight: true,
            photoIndex: {},
            photoError: {},

            options: {
                salesPromoterSearch: this.salesPromoterSearch,
                marketNetworkSearch: [],
                marketSearch: [],
                providerSearch: [],
                brandSearch: [],
                productSearch: [],
                statesSearch: [],
                citysSearch: [],
                zoneSearch: [],
            },

            listColumns: [
                {
                    uniqid: 'sales_promoter_label',
                    label: 'Promotor',
                    field: 'sales_promoter_label',
                    visible: true,
                    sortable: true,
                    classes: 'border-b text-sm',
                },
            ],

            leftColumns: [
                {
                    uniqid: 'sales_promoter_label',
                    label: 'Promotor',
                    field: 'sales_promoter_label',
                    visible: true,
                    sortable: true,
                },
            ],

            selectedRow: null,

            options_sim_nao: [
                { label: 'Não', value: 0, name: 'no_stock' },
                { label: 'Sim', value: 1, name: 'no_stock' },
            ],

            productOptionsDisp: [],
            _observers: {
                left: null,
                right: null,
            },
        }
    },

    computed: {
        getQuery() {
            return Object.entries(this.getFilters()).map(([key, val]) => `search2[${key}]=${val}`).join('&')
        },
    },

    watch: {
        'filters.ActivityManagement': {
            handler() {
                this.getFiltersFromAPI()
            },
            deep: true,
        },
        loadTable(val) {
            if (val) {
                this.$nextTick(() => this.createObservers());
            }
        }
    },

    methods: {
        onModalSubmit(item) {
            this.$toast && this.$toast.success('Ação concluída')
            this.reloadTable()
        },
        onModalError(item) {
            this.$toast && this.$toast.error('Falha ao enviar')
        },
        formatDate(date) {
            try {
                // Retorna apenas a parte de data no padrão brasileiro
                const d = new Date(date)
                if (!isNaN(d)) {
                    return d.toLocaleDateString('pt-BR')
                }
            } catch (e) { /* noop */ }
            // Fallback para o formatDateTime existente pegando só a data
            try {
                const full = this.formatDateTime(date)
                // tenta extrair dd/mm/aaaa de uma string com data e hora
                const match = full && full.match(/\b(\d{2}\/\d{2}\/\d{4})\b/)
                return match ? match[1] : full
            } catch (e) {
                return ''
            }
        },
        updateTotalLeft(total) {
            if (Number.isFinite(total)) this.totalLeft = total
            return true
        },
        reloadData() {
            this.getFiltersFromAPI()
            this.reloadTable()
        },

        reloadTable() {
            const leftEl = this.$refs.leftScroll
            const rightEl = this.$refs.rightScroll
            const leftTop = leftEl ? leftEl.scrollTop : null
            const rightTop = rightEl ? rightEl.scrollTop : null

            try { this.$refs.leftTable && this.$refs.leftTable.reloadData && this.$refs.leftTable.reloadData() } catch { }
            try { this.$refs.rightTable && this.$refs.rightTable.reloadData && this.$refs.rightTable.reloadData() } catch { }

            this.$nextTick(() => {
                if (leftEl && leftTop != null) leftEl.scrollTop = leftTop
                if (rightEl && rightTop != null) rightEl.scrollTop = rightTop
            })
        },
        clearSearch() {
            this.clearFilters()
            this.getFiltersFromAPI()
            this.reloadTable();
        },

        handleApprove(row) {
            this.$refs.modalAprovar && this.$refs.modalAprovar.openModalEdit({
                reportId: row.reportId,
                activityId: row.activitiesId,
                type: 'activity',
                status: 3,
                errors: {},
            })
        },

        handleOrient(row) {
            this.$refs.modalReprovar && this.$refs.modalReprovar.openModalEdit({
                reportId: row.reportId,
                activityId: row.activitiesId,
                type: 'activity',
                feedback: '',
                status: 1,
                errors: {},
            })
        },

        handleDelete(row) {
            this.$refs.modalExcluir && this.$refs.modalExcluir.openModalEdit({
                reportId: row.reportId,
                activityId: row.activitiesId,
                type: 'activity',
                status: 3,
                errors: {},
            })
        },

        // Normalização para modal de edição (fotos e produtos)

        async handleEdit(row) {
            let photosRaw = []
            if (Array.isArray(row.photos) && row.photos.length) {
                photosRaw = row.photos
            } else if (row.photo) {
                photosRaw = [row.photo]
            } else if (row.photoUrl) {
                photosRaw = [row.photoUrl]
            }
            const photo = photosRaw
                .map(ph => {
                    if (!ph) return null
                    if (typeof ph === 'string') return { url: ph }
                    if (ph.url) return { url: ph.url }
                    if (ph.path) return { url: ph.path }
                    return ph
                })
                .filter(Boolean)

            // Busca produtos do fornecedor ao abrir o modal
            const providerId = row.fornecedor_id || row.provider_id || row.provider || row.providerId;
            this.productOptionsDisp = [];
            if (providerId) {
                try {
                    const { data } = await axios.get(`/activity_management/products-by-provider/${providerId}`);
                    const produtos = data.products || [];
                    this.productOptionsDisp = produtos.map(p => ({
                        value: p.id,
                        label: p.name
                    }));
                } catch (e) {
                    this.productOptionsDisp = [];
                }
            }
            // Seleção dos produtos já vinculados à atividade
            let produtoSelecionados = []
            if (Array.isArray(row.products) && row.products.length) {
                produtoSelecionados = row.products.map(p => {
                    let raw = p?.id ?? p?.productId ?? p?.value ?? p?.product_id ?? p?.products_id
                    if (raw == null) {
                        const name = p?.name ?? p?.productName ?? String(p)
                        const found = this.productOptionsDisp.find(o => String(o.label).toLowerCase() === String(name).toLowerCase())
                        if (found) raw = found.value
                    }
                    const num = Number(raw)
                    return Number.isNaN(num) ? raw : num
                })
            } else if (Array.isArray(row.productIds)) {
                produtoSelecionados = row.productIds
            } else if (Array.isArray(row.productsIds)) {
                produtoSelecionados = row.productsIds
            } else if (Array.isArray(row.product_ids)) {
                produtoSelecionados = row.product_ids
            } else if (Array.isArray(row.products_id)) {
                produtoSelecionados = row.products_id
            }
            produtoSelecionados = (produtoSelecionados || [])
                .filter(v => v != null && (typeof v !== 'object'))
                .map(v => {
                    const n = Number(v)
                    return Number.isNaN(n) ? v : n
                })
            const seen = new Set()
            produtoSelecionados = produtoSelecionados.filter(v => (seen.has(String(v)) ? false : (seen.add(String(v)), true)))

            this.$refs.modalEdit && this.$refs.modalEdit.openModalEdit({
                activity: row.activitiesId,
                market: row.marketId,
                marketNetwork: row.marketNetworkId || row.marketNetWorkId,
                report: row.reportId,
                provider: providerId,
                salesPromoter: row.salesPromoterId || row.sales_promoter_id,
                products: produtoSelecionados,
                description: row.description,
                nostock: row.nostock ? 1 : 0,
                photo: photo,
                errors: {}
            })
        },

        ensurePhotoIndex(row) {
            const key = row.activitiesId
            if (this.photoIndex[key] == null) this.photoIndex[key] = 0
            return key
        },

        getPhotos(row) {
            if (row && Array.isArray(row.photos) && row.photos.length) return row.photos
            if (row && row.photoUrl) return [row.photoUrl]
            return []
        },

        isPhotoActive(row, idx) {
            const key = this.ensurePhotoIndex(row)
            return this.photoIndex[key] === idx
        },

        selectPhoto(row, idx) {
            const key = this.ensurePhotoIndex(row)
            const photos = this.getPhotos(row)
            if (!photos.length) return
            this.photoIndex[key] = Math.max(0, Math.min(idx, photos.length - 1))
            // limpa erro ao trocar de mídia
            this.photoError[key] = false
        },

        currentPhoto(row) {
            const key = this.ensurePhotoIndex(row)
            const photos = row.photos && row.photos.length ? row.photos : (row.photoUrl ? [row.photoUrl] : [])
            if (!photos.length) return null
            return photos[this.photoIndex[key] % photos.length]
        },

        prevPhoto(row) {
            const key = this.ensurePhotoIndex(row)
            const photos = row.photos && row.photos.length ? row.photos : (row.photoUrl ? [row.photoUrl] : [])
            if (!photos.length) return
            this.photoIndex[key] = (this.photoIndex[key] - 1 + photos.length) % photos.length
            // limpa erro ao trocar de mídia
            this.photoError[key] = false
        },

        nextPhoto(row) {
            const key = this.ensurePhotoIndex(row)
            const photos = row.photos && row.photos.length ? row.photos : (row.photoUrl ? [row.photoUrl] : [])
            if (!photos.length) return
            this.photoIndex[key] = (this.photoIndex[key] + 1) % photos.length
            // limpa erro ao trocar de mídia
            this.photoError[key] = false
        },

        canNavigate(row) {
            const photos = this.getPhotos(row)
            return photos.length > 1
        },

        showImage(row) {
            const key = this.ensurePhotoIndex(row)
            const url = this.currentPhoto(row)
            return !!url && !this.photoError[key]
        },

        onImageError(row) {
            const key = this.ensurePhotoIndex(row)
            this.photoError[key] = true
        },

        getImageFallbackText(row) {
            const key = this.ensurePhotoIndex(row)
            const photos = this.getPhotos(row)
            if (!photos.length) return 'Nenhuma imagem disponível'
            if (this.photoError[key]) return 'Esta imagem foi removida automaticamente por uma regra de limpeza do sistema'
            return 'Imagem da atividade'
        },

        labelMedia(idx) {
            const n = idx + 1
            return `Mídia ${String(n).padStart(2, '0')}`
        },

        getImageUrl(row) {
            if (row?.media && Array.isArray(row.media) && row.media.length) {
                return row.media[0].url || row.media[0].path
            }
            return row?.photo || row?.image || null
        },

        formatDateTime(date) {
            try {
                return this.$filters ? this.$filters.formatDateTime(date) : new Date(date).toLocaleString('pt-BR')
            } catch {
                return new Date(date).toLocaleString('pt-BR')
            }
        },

        // Ao clicar na linha da direita, aplica o filtro de promotor ao invés de abrir card na esquerda
        applyPromoterFilter(row) {
            const id = row?.salesPromoterId ?? row?.sales_promoter_id ?? row?.sales_promoter ?? row?.salesPromoter
            if (id == null) {
                this.$toast && this.$toast.info('Não foi possível identificar o promotor para filtrar.')
                return
            }
            // evita abrir o card da esquerda
            this.selectedRow = null
            // garante estrutura do objeto de filtros
            this.filters.ActivityManagement = this.filters.ActivityManagement || {}
            // aplica seleção (multi-select aceita array)
            this.filters.ActivityManagement.sales_promoter = [Number(id) || id]
            // recarrega dados e mantém UX consistente
            this.reloadData()
        },

        createObservers() {
            if (this._observers.left) {
                try { this._observers.left.disconnect(); } catch { }
                this._observers.left = null;
            }
            if (this._observers.right) {
                try { this._observers.right.disconnect(); } catch { }
                this._observers.right = null;
            }

            const build = (sentinelRef, tableRef, scrollRef) => {
                const el = this.$refs[sentinelRef];
                const table = this.$refs[tableRef];
                const root = this.$refs[scrollRef] || null;
                if (!el || !table) return;
                if (!table.$attrs || table.$attrs['infinite-scroll'] === false || table.$attrs['infiniteScroll'] === false) {
                    return null;
                }
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            const t = table.$refs?.table;
                            const hasNext = t && t.next_page_url;
                            const loading = t && t.isLoading;
                            const infinite = t && t.$props && t.$props.infiniteScroll;
                            if (infinite && hasNext && !loading) {
                                table.loadNextPage && table.loadNextPage();
                            }
                        }
                    })
                }, { root: root, threshold: 0.5 });
                observer.observe(el);
                return observer;
            };
            this._observers.left = build('leftSentinel', 'leftTable', 'leftScroll');
            this._observers.right = build('rightSentinel', 'rightTable', 'rightScroll');
        }
    },


    setup() {
        const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

        setFiltersComponent('ActivityManagement')

        const clearFilters = () => clearFiltersComponent('ActivityManagement')
        const getFilters = () => getFiltersComponent('ActivityManagement')

        return {
            getFilters,
            clearFilters,
            filters: filtersStore.filters
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.createObservers();
        });
    },
    beforeUnmount() {
        if (this._observers.left) try { this._observers.left.disconnect(); } catch { }
        if (this._observers.right) try { this._observers.right.disconnect(); } catch { }
    },
};
</script>

<style scoped>
/* Additional styles if needed */
</style>
